"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fuCardOrderDetail = _interopRequireDefault(require("@/views/orderList/order/fuCard/fuCardOrderDetail.vue"));
var _fuCardApi = require("@/api/fuCardApi");
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi"));
var _Item = _interopRequireDefault(require("@/layout/components/Sidebar/Item"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SanjiangOrderList',
  components: {
    OrderDetailComponent: _fuCardOrderDetail.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        //页码
        limit: this.$constants.page.limit[0],
        //每页数量
        orderStatus: '',
        //订单状态
        orderNo: '',
        //订单号
        waterMeterCode: '',
        //水表号
        phone: '',
        //手机号
        startTime: '',
        //开始时间
        endTime: '' //结束时间
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      dateRange: [],
      detailDialogVisible: false,
      orderDetail: null,
      currentOrderId: null,
      detailLoading: false,
      // 订单状态选项
      orderStatusOptions: [{
        label: "已取消",
        value: 0
      }, {
        label: "待支付",
        value: 1
      }, {
        label: "已支付",
        value: 2
      }, {
        label: "处理中",
        value: 3
      }, {
        label: "已完结",
        value: 6
      }, {
        label: "退款中",
        value: 7
      }, {
        label: "退款成功",
        value: 8
      }, {
        label: "退款失败",
        value: 9
      }, {
        label: "拒绝退款",
        value: 10
      }, {
        label: "已关闭",
        value: 11
      }, {
        label: "支付失败",
        value: 12
      }, {
        label: "向第三方下单失败",
        value: 13
      }, {
        label: "部分退款",
        value: 14
      }, {
        label: "售后中",
        value: 15
      }],
      customers: []
    };
  },
  mounted: function mounted() {
    this.loadOrderList();
    this.getCustomers();
  },
  methods: {
    // 日期范围变化处理
    handleDateRangeChange: function handleDateRangeChange(value) {
      if (value && value.length === 2) {
        this.listPram.startTime = value[0];
        this.listPram.endTime = value[1];
      } else {
        this.listPram.startTime = '';
        this.listPram.endTime = '';
      }
    },
    getAppName: function getAppName(customerId) {
      var app = this.customers.find(function (item) {
        return item.id == customerId;
      });
      return app.name;
    },
    getCustomers: function getCustomers() {
      var _this = this;
      this.customers = [];
      orderListApi.activeCustomersApi().then(function (res) {
        _this.customers = res;
      });
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.loadOrderList();
    },
    // 加载订单列表的统一方法
    loadOrderList: function loadOrderList() {
      var _this2 = this;
      this.listLoading = true;
      console.log('搜索参数:', this.listPram);
      (0, _fuCardApi.getFuCardList)(this.listPram).then(function (res) {
        console.log('获取订单列表成功:', res);
        if (res.list.length > 0) {
          _this2.listData = res;
          console.log(_this2.listData);
        } else {
          _this2.$message.error(res.message || '获取订单列表失败');
          _this2.listData = {
            list: [],
            total: 0
          };
        }
      }).catch(function (error) {
        console.error('获取订单列表失败:', error);
        _this2.$message.error('获取订单列表失败，请稍后重试');
        _this2.listData = {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this2.listLoading = false;
      });
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderStatus: '',
        orderNo: '',
        waterMeterCode: '',
        phone: '',
        startTime: '',
        endTime: ''
      };
      this.dateRange = [];
      this.loadOrderList();
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(row) {
      this.currentOrderId = row.orderNo;
      this.orderDetail = row;
      this.detailDialogVisible = true;
    },
    // 关闭订单详情弹窗
    handleDetailClose: function handleDetailClose() {
      this.detailDialogVisible = false;
      this.orderDetail = {};
      this.currentOrderId = null;
      this.detailLoading = false;
    },
    // 处理详情加载状态变化
    handleDetailLoadingChange: function handleDetailLoadingChange(loading) {
      this.detailLoading = loading;
    },
    // 处理详情数据加载完成
    handleDetailLoaded: function handleDetailLoaded(detail) {
      this.orderDetail = detail;
    },
    // 处理详情加载错误
    handleDetailError: function handleDetailError(error) {
      this.$message.error('获取订单详情失败: ' + error.message);
    },
    // 分页大小变化
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.listPram.page = 1; // 改变每页数量时重置到第一页
      this.loadOrderList();
    },
    // 当前页变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.loadOrderList(); // 直接调用数据加载方法，不重置页码
    },
    // 导出订单
    exportOrder: function () {
      var _exportOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var downloadUrl, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _fuCardApi.exportOrderList)(this.listPram);
            case 1:
              downloadUrl = _context.v;
              console.log('导出订单下载链接>>>>>>>>>>>>>>:', downloadUrl);

              // 检查是否获取到下载链接
              if (downloadUrl && typeof downloadUrl.fileName === 'string') {
                this.downloadFileFromUrl(downloadUrl);
                this.$message.success('订单导出成功！');
              } else {
                this.$message.error('导出失败：未获取到有效的下载链接');
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('导出订单失败:', _t);
              this.$message.error('导出订单失败，请稍后重试');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function exportOrder() {
        return _exportOrder.apply(this, arguments);
      }
      return exportOrder;
    }(),
    // 通过URL下载文件的通用方法
    downloadFileFromUrl: function downloadFileFromUrl(url) {
      var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      try {
        // 如果没有指定文件名，则根据时间戳生成
        var defaultFilename = "\u8BA2\u5355\u5BFC\u51FA_".concat(new Date().getTime(), ".xlsx");
        var downloadFilename = filename || defaultFilename;

        // 创建隐藏的下载链接
        var link = document.createElement('a');
        link.href = url;
        link.download = downloadFilename;
        link.style.display = 'none';
        link.target = '_blank'; // 在新窗口打开，避免页面跳转

        // 添加到DOM，触发下载，然后移除
        document.body.appendChild(link);
        link.click();

        // 延迟移除元素，确保下载正常触发
        setTimeout(function () {
          document.body.removeChild(link);
        }, 100);
      } catch (error) {
        console.error('文件下载失败:', error);
        this.$message.error('文件下载失败，请检查链接是否有效');
      }
    }
  }
};